import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import clsx from 'clsx'
import Drawer from '@mui/material/Drawer'
import { SideBarMenu } from './components/side-bar'
import { TopBar } from './components/top-bar'
import { Container } from '@mui/material'
import { AppRouter } from './routes/AppRouter'
import { IAuthService } from './modules/auth/services/AuthService'
import React, { useEffect, useState } from 'react'
import { LoggedUser } from './modules/auth/models/LoggedUser'
import { getAuthContainer } from './container/auth-modules'
import { AUTH_SERVICE_KEY } from './modules/auth'
import i18n from 'i18next'
import { Login } from './pages/login/Login'
import { MaintenanceGuard } from 'MaintenanceGuard'
import logoB from './assets/Logo/bioarray-logo.png'

console.log(logoB)

const authService = getAuthContainer().get<IAuthService>(AUTH_SERVICE_KEY)

const App = () => {
  const classes = useStyles()
  const [loggedUser, setLoggedUser] = useState<LoggedUser>(authService.get())

  useEffect(() => {
    if (loggedUser?.id == '') {
      if (navigator.language?.includes('es')) {
        i18n.changeLanguage('es')
      } else {
        i18n.changeLanguage('en')
      }
    } else {
      i18n.changeLanguage(loggedUser.language)
    }

    authService.getObservable().subscribe((u) => {
      setLoggedUser(u)
      i18n.changeLanguage(u.language)
    })
  }, [])


//bypass token ===> skip
  return (
    
    <MaintenanceGuard appSlug='GLOBAL' appName='GLOBAL' serviceUrl='https://smcguard.bioarray.es' logo={logoB}>
      {loggedUser.id ? (
        <div className={classes.root}>
          <div className={classes.container}>
            <Drawer
              variant="permanent"
              classes={{
                paper: clsx(classes.drawer),
              }}>
              <SideBarMenu />
            </Drawer>

            <main className={classes.main}>
              <Container>
                <TopBar />
                <AppRouter />
              
              </Container>
            </main>
          </div>
        </div>
      ) : (
        <>
          <AppRouter />
          <Login />
        </>
      )}
    </MaintenanceGuard>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  container: {
    display: 'flex',
    flex: 1,
  },
  sidebarmenu: {
    marginTop: theme.spacing(5),
  },
  drawer: {
    background: theme.palette.grey.A100,
    //position: 'static',
    transition: 'width .7s',
    width: '25rem',

    zIndex: 1101,
  },
  main: {
    flex: 1,
    background: theme.palette.common.white,
    paddingTop: theme.spacing(11),
    marginLeft: '25rem',
  },
}))

export default App
